$(window).scroll(function(){
      if ($(this).scrollTop() > 120) {
          $('.header').addClass('fixed');
      } else {
          $('.header').removeClass('fixed');
      }
});


$(document).on("click",".collection-tab-title",function(){

  var id_tab=$(this).attr("id");
  $(".collection-tab-title").removeClass("active");
  $(this).addClass("active");
  
  $(".tab_body").removeClass("active");
  $(".tab_body#"+id_tab).addClass("active");
});



$(document).ready(function(){
$('#customer_reviews').owlCarousel({
	     margin:30,
	     loop:true,
	     autoHeight: false,
    autoHeightClass: 'owl-height',
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:true,
		center:true,
		nav:false,
		pagination:false,  dots: false,
		navText: ["<img src='https://cdn.shopify.com/s/files/1/0628/0632/7543/files/Mask_group_22.png?v=1714353042'>","<img src='https://cdn.shopify.com/s/files/1/0628/0632/7543/files/Mask_group_21.png?v=1714353041'>"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2,
                nav:true
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:4	
	        }
	    }
	}); 
	 
});
